import { getProductView_productDetailByMasterId } from '@containers/ProductDetailContainer/queries/__generated__/getProductView';
import { variantFragment } from '@containers/ProductDetailContainer/queries/__generated__/variantFragment';
import { TrackingAttributes } from '@context/tracking/types';
import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';

const trackDrawerEvent = (args: {
  timing: number;
  mode: string;
  interaction: string;
}) => {
  dispatchTrackingEvent({
    event: 'element_click',
    element: {
      mode: 'open',
      name: 'Drawer',
      interaction: 'click',
      action: '',
      promo_labels: undefined,
      type: 'drawer',
      ...args,
    },
    _clear: true,
  });
};

export const trackDrawerOpen = ({
  timing,
}: Pick<TrackingAttributes, 'timing'>) => {
  trackDrawerEvent({
    mode: 'open',
    timing,
    interaction: 'click',
  });
};

export const trackDrawerClose = ({
  timing,
  closeType,
}: Omit<TrackingAttributes<{ closeType: string }>, 'variant'>) => {
  let eventLabel;
  switch (closeType) {
    case 'outside-click':
      eventLabel = 'Close-Out';
      break;
    case 'icon':
      eventLabel = 'Close-X';
      break;
    case 'slide-down':
      eventLabel = 'Close-Slide';
      break;
    case 'slide-down-position-velocity':
      eventLabel = 'Close-Slide-Position-Velocity';
      break;
    case 'slide-down-position':
      eventLabel = 'Close-Slide-Position';
      break;
    case 'slide-down-velocity':
      eventLabel = 'Close-Slide-Velocity';
      break;
    case 'escape':
      eventLabel = 'Escape';
      break;
    case 'browser-back':
      eventLabel = 'Browser-Back';
      break;
  }

  trackDrawerEvent({
    mode: 'close',
    interaction: eventLabel,
    timing,
  });
};

export const trackResizeToTop = ({
  timing,
}: Pick<TrackingAttributes, 'timing'>) => {
  trackDrawerEvent({
    mode: 'open',
    interaction: 'resize+',
    timing,
  });
};

export const trackResizeToMiddle = ({
  timing,
}: Pick<TrackingAttributes, 'timing'>) => {
  trackDrawerEvent({
    mode: 'open',
    interaction: 'resize-',
    timing,
  });
};

export const trackDrawerVariantClick = ({
  timing,
}: Pick<TrackingAttributes, 'timing'>) => {
  trackDrawerEvent({
    mode: undefined,
    interaction: 'select_variant',
    timing,
  });
};

export const trackDrawerWatchdogClick = (
  product: getProductView_productDetailByMasterId,
  variant: variantFragment
) => {
  dispatchTrackingEvent({
    event: 'watchdog_click',
    watchdog: {
      action: 'wt_add_watchdog',
      interaction: 'button',
      type: 'Drawer',
      products: [
        ProductEventWither()
          .withProduct(product)
          .withPartialVariant({
            ...variant,
            price: {
              __typename: 'Price',
              ...variant.price,
            },
            stockAvailability: {
              code: variant.stockAvailability.code,
              __typename: 'StockInfo',
              count: undefined,
            },
          })
          .build(),
      ],
    },
    _clear: true,
  });
};
